var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearAttraction(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1884_5854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8176 5.16992L9.61569 8.77486C9.55027 8.97112 9.44006 9.14946 9.29378 9.29574C9.1475 9.44202 8.96917 9.55223 8.77291 9.61764L5.16797 10.8195L6.36984 7.21457C6.43525 7.01831 6.54546 6.83998 6.69174 6.6937C6.83802 6.54741 7.01636 6.4372 7.21261 6.37179L10.8176 5.16992Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99428 14.657C11.6737 14.657 14.6565 11.6742 14.6565 7.99477C14.6565 4.31531 11.6737 1.33252 7.99428 1.33252C4.31482 1.33252 1.33203 4.31531 1.33203 7.99477C1.33203 11.6742 4.31482 14.657 7.99428 14.657Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1884_5854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9894,
    height: 15.9894,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearAttraction);
export default __webpack_public_path__ + "static/media/nearAttraction.f09090080da54fa419e048fd62708188.svg";
export { ForwardRef as ReactComponent };